(function () {
  // Vehicle pages (GemPages product templates on france.niu.com). The six templates were built separately and
  // share one buybox layout, so this tidies them in one place instead of in each template:
  // price under the title, the "3 étapes" text once, the FAQ below the buybox, and the spec accordion as key
  // figures plus a table. The GemPages elements stay the source of the content and can still be edited there.
  const STEPS = /en 3 [ée]tapes/i;
  // "1 999 €", or one line per option such as "1 batterie : 1 999 €" / "Standard Range : 1 999 €"
  const PRICE_LINE = /^\s*\d[\d\s]*\s?€|^[^:€]{1,40}:\s*\d[\d\s]*\s?€/;
  // "3 499 € au lieu de 4 499 €" (offer price, then the old price)
  const DEAL = /(\d[\d\s]*\d\s?€)\s*\*?\s*au lieu de\s*(\d[\d\s]*\d\s?€)/i;
  const SPECS = /caract[ée]ristiques/i;
  // Figures shown as large tiles above the table, in this order, when the spec table has them
  const KEY_FIGURES = [/^vitesse max/i, /^autonomie/i, /^puissance max/i, /^temps de charge/i];

  function toNumber(text) {
    return parseInt(text.replace(/[^\d]/g, ''), 10);
  }

  function columnChildren(column) {
    return Array.from(column.children).filter(function (el) { return el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE'; });
  }

  // Launch-offer layout (BQi): "Offre de lancement : 2 199,00 € 1 999,00 €" followed by free text. Rebuilt like the
  // other vehicles: offer price under the title, the purchase steps as a numbered list
  const LAUNCH = /offre de lancement\s*:\s*(\d[\d\s,]*\d)\s*€\s*(\d[\d\s,]*\d)\s*€/i;
  function euros(text) { return parseInt(text.replace(/,\d+$/, '').replace(/[^\d]/g, ''), 10); }
  function formatEuros(value) { return value.toLocaleString('fr-FR').replace(/\s/g, ' ') + ' €'; }
  function tidyLaunchOffer(items, titleItem) {
    const blocks = items.filter(function (el) { return LAUNCH.test(el.textContent.replace(/\s+/g, ' ')) && !el.querySelector('gp-product-button'); });
    if (!blocks.length || !titleItem) return;
    const match = blocks[0].textContent.replace(/\s+/g, ' ').match(LAUNCH);
    const was = euros(match[1]);
    const now = euros(match[2]);
    const price = document.createElement('div');
    price.className = 'niu-pdp-deal';
    price.innerHTML = '<div class="niu-price"><span class="niu-price__now"><span class="niu-sr">Prix : </span>' + formatEuros(now) + '</span>' +
      '<s class="niu-price__was"><span class="niu-sr">Ancien prix : </span>' + formatEuros(was) + '</s>' +
      (was > now ? '<span class="niu-price__save">−' + formatEuros(was - now) + '</span>' : '') + '</div>';
    titleItem.after(price);
    blocks.slice(0, -1).forEach(function (el) { el.classList.add('niu-hidden'); });
    blocks[blocks.length - 1].innerHTML = '<p><strong>Achète ton vélo en 3 étapes :</strong></p><ol>' +
      '<li><strong>Réserve en ligne</strong> Paie un acompte de 100 €, remboursable à tout moment, et choisis le revendeur le plus proche de chez toi.</li>' +
      '<li><strong>Livraison chez ton revendeur</strong> Ton vélo y arrive sous 14 jours, préparé et prêt à rouler.</li>' +
      '<li><strong>Récupère ton vélo</strong> Règle le solde de ' + formatEuros(now - 100) + ' à la remise et repars.</li></ol>';
  }

  // NQiX 500: the price and the steps heading share one paragraph above the buttons, and the steps list below the
  // buttons has no heading. The heading moves to the list, so the buybox reads like the other vehicles. GemPages
  // fills the list in after the buybox has been tidied, so this is tried again on every pass until it is done
  const STEP_LIST = /r[ée]serve en ligne/i;
  function moveStepsHeading() {
    const column = document.querySelector('[data-niu-tidy]');
    if (!column) return;
    const items = columnChildren(column);
    const priceWithHeading = items.find(function (el) { return STEPS.test(el.textContent) && !STEP_LIST.test(el.textContent); });
    const bareList = items.filter(function (el) { return STEP_LIST.test(el.textContent) && !STEPS.test(el.textContent) && el.querySelector('ol, ul'); }).pop();
    const stepsHeading = priceWithHeading && bareList && Array.from(priceWithHeading.querySelectorAll('span, strong')).find(function (el) { return STEPS.test(el.textContent); });
    if (!stepsHeading) return;
    priceWithHeading.querySelectorAll('br').forEach(function (br) { br.remove(); });
    const headingLine = document.createElement('p');
    headingLine.append(stepsHeading);
    bareList.querySelector('ol, ul').before(headingLine);
    priceWithHeading.classList.remove('niu-steps');
    bareList.classList.add('niu-steps');
  }

  // Vehicles reach the dealer within 14 days (the shop's delivery time for scooters and motorcycles); the step where
  // the dealer takes over says so on every vehicle page
  const DEALER_STEP = /finalis/i;
  function addDeliveryTime() {
    document.querySelectorAll('.niu-steps li').forEach(function (step) {
      const label = step.querySelector('strong, b');
      if (!label || !DEALER_STEP.test(label.textContent) || step.querySelector('.niu-delivery')) return;
      const note = document.createElement('span');
      note.className = 'niu-delivery';
      note.textContent = ' Ton NIU arrive chez ton concessionnaire sous 14 jours.';
      step.append(note);
    });
  }

  function tidyBuybox() {
    // The buybox title, not one of the product cards further down the page
    const title = Array.from(document.querySelectorAll('product-form gp-product-title')).find(function (el) { return !el.closest('div.gp-grid > gp-product, gp-same-height, gp-carousel-v3'); });
    if (!title) return;
    const row = title.closest('gp-row');
    const column = Array.from(row.children).find(function (el) { return el.contains(title); });
    if (!column || column.dataset.niuTidy) return;
    column.dataset.niuTidy = '1';
    const items = columnChildren(column);
    const titleItem = items.find(function (el) { return el.contains(title); });
        if (!items.some(function (el) { return STEPS.test(el.textContent); })) tidyLaunchOffer(items, titleItem);

    // The steps text appears twice (above the price and below the buttons): keep the lower one
    const steps = items.filter(function (el) { return STEPS.test(el.textContent) && !el.querySelector('gp-accordion'); });
    steps.slice(0, -1).forEach(function (el) { el.classList.add('niu-hidden'); });
    if (steps.length) steps[steps.length - 1].classList.add('niu-steps');

    // The full price ("1 999 €" or one line per battery option) sits below the buttons; it belongs under the title
    const price = items.find(function (el) {
      const text = el.textContent.trim();
      return text.length < 120 && PRICE_LINE.test(text) && !el.querySelector('gp-product-price, gp-product-button');
    });
    if (price && titleItem) {
      const deal = price.textContent.replace(/\s+/g, ' ').match(DEAL);
      if (deal) {
        // Same treatment as the collection cards: large price, old price struck through, saving in red
        const saving = toNumber(deal[2]) - toNumber(deal[1]);
        price.innerHTML = '<div class="niu-price"><span class="niu-price__now"><span class="niu-sr">Prix : </span>' + deal[1] + '</span>' +
          '<s class="niu-price__was"><span class="niu-sr">Ancien prix : </span>' + deal[2] + '</s>' +
          (saving > 0 ? '<span class="niu-price__save">−' + saving.toLocaleString('fr-FR').replace(/\s/g, ' ') + ' €</span>' : '') + '</div>';
        price.classList.add('niu-pdp-deal');
      } else {
        price.classList.add('niu-pdp-price');
      }
      titleItem.after(price);
    }

    // FAQ accordion: out of the buybox, into its own block under the section
    const faq = items.find(function (el) { return el.querySelector('gp-accordion') && !SPECS.test(el.textContent); });
    const section = row.closest('section');
    if (faq && section) {
      const block = document.createElement('section');
      block.className = 'niu-pdp-faq';
      block.innerHTML = '<div class="niu-pdp-faq__wrap"><h2 class="niu-pdp-faq__title">Questions fréquentes</h2></div>';
      block.firstChild.append(faq);
      section.after(block);
    }
  }

  // Cell text with its line breaks kept: GemPages sets multi-line values ("Mode 0 : sans assistance" /
  // "Mode 1, 2 et 3 : …") as separate paragraphs, which textContent would glue together
  function cellText(el) {
    const copy = el.cloneNode(true);
    copy.querySelectorAll('br').forEach(function (br) { br.replaceWith('\n'); });
    copy.querySelectorAll('p, div, li').forEach(function (block) { block.append('\n'); });
    return copy.textContent.split('\n').map(function (line) { return line.trim().replace(/\s+/g, ' '); }).filter(Boolean).join('\n');
  }

  function cellsOf(specRow) {
    return Array.from(specRow.children)
      .filter(function (el) { return el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE'; })
      .map(cellText);
  }

  function readSpecs(accordion) {
    return Array.from(accordion.querySelectorAll('.gp-accordion-item_header')).map(function (header) {
      const body = header.parentElement.querySelector('.gp-accordion-item_body');
      // Leaf rows only: one label cell plus one value cell per model variant
      const rows = body ? Array.from(body.querySelectorAll('gp-row')).filter(function (r) { return !r.querySelector('gp-row'); }) : [];
      let cells = rows.map(cellsOf).filter(function (c) { return c.some(Boolean); });
      // A first row with an empty label holds the column names (e.g. "1 batterie" / "2 batteries")
      let head = cells.length && !cells[0][0] ? cells.shift().slice(1) : null;
      // Dimension groups (Taille) are a drawing plus lines like "1. Hauteur : 1 130 mm", one value for all variants;
      // the numbers point into the drawing, which the table does not show, so they are dropped
      let shared = false;
      if (body && !cells.some(function (c) { return c.filter(Boolean).length > 1; })) {
        const lines = Array.from(body.querySelectorAll('p')).map(function (p) {
          return p.textContent.trim().replace(/\s+/g, ' ').match(/^(?:\d+\.\s*)?([^:]+?)\s*:\s*(.+)$/);
        }).filter(Boolean);
        if (lines.length) {
          cells = lines.map(function (m) { return [m[1], m[2]]; });
          head = null;
          shared = true;
        }
      }
      return { title: header.textContent.trim().replace(/\s+/g, ' '), head: head, rows: cells, shared: shared };
    });
  }

  function escapeHtml(text) {
    return text.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function cellHtml(text) { return escapeHtml(text).replace(/\n/g, '<br>'); }

  // "60–65 km" and "120–130 km" become one tile value "60–65 / 120–130" with the unit "km"
  function figure(values) {
    const parts = values.map(function (v) { return v.match(/^([\d\s.,–\-\/×]+)\s*(.*)$/); });
    if (parts.some(function (p) { return !p; })) return null;
    const numbers = parts.map(function (p) { return p[1].trim(); });
    const unique = numbers.filter(function (n, i) { return numbers.indexOf(n) === i; });
    return { value: unique.join(' / '), unit: parts[parts.length - 1][2] };
  }

  function buildSpecs(sections) {
    const all = [].concat.apply([], sections.map(function (s) { return s.rows; }));
    const tiles = KEY_FIGURES.map(function (pattern) {
      const row = all.find(function (r) { return pattern.test(r[0]); });
      const fig = row && figure(row.slice(1).filter(Boolean));
      return fig ? '<div class="niu-specs__tile"><span class="niu-specs__value">' + escapeHtml(fig.value) + '<small>' + escapeHtml(fig.unit) + '</small></span><span class="niu-specs__label">' + escapeHtml(row[0]) + '</span></div>' : '';
    }).join('');
    // One column grid for every group, so the values stay in line from one group to the next
    const columns = Math.max.apply(null, [1].concat(sections.map(function (s) {
      return Math.max.apply(null, [s.head ? s.head.length : 0].concat(s.rows.map(function (r) { return s.shared ? 1 : r.length - 1; })));
    })));
    const cols = '<colgroup><col class="niu-specs__col-label">' + new Array(columns + 1).join('<col>') + '</colgroup>';
    // Each group folds open and shut; the first (main characteristics) starts open, the others closed
    const tables = sections.map(function (s, index) {
      const head = s.head ? '<thead><tr><th></th>' + s.head.map(function (h) { return '<th scope="col">' + cellHtml(h) + '</th>'; }).join('') + '</tr></thead>' : '';
      const body = s.rows.map(function (r) {
        const values = s.shared ? '<td colspan="' + columns + '">' + cellHtml(r[1]) + '</td>' : r.slice(1).map(function (v) { return '<td>' + cellHtml(v) + '</td>'; }).join('');
        return '<tr><th scope="row">' + cellHtml(r[0]) + '</th>' + values + '</tr>';
      }).join('');
      return '<details class="niu-specs__group"' + (index === 0 ? ' open' : '') + '><summary class="niu-specs__group-title">' + escapeHtml(s.title) + '</summary><table class="niu-specs__table">' + cols + head + '<tbody>' + body + '</tbody></table></details>';
    }).join('');
    const block = document.createElement('div');
    block.className = 'niu-specs';
    block.innerHTML = '<h2 class="niu-specs__title">Caractéristiques techniques</h2>' + (tiles ? '<div class="niu-specs__tiles">' + tiles + '</div>' : '') + '<div class="niu-specs__groups">' + tables + '</div>';
    return block;
  }

  function restyleSpecs() {
    const accordion = Array.from(document.querySelectorAll('gp-accordion')).find(function (a) {
      const first = a.querySelector('.gp-accordion-item_header');
      return first && SPECS.test(first.textContent) && !a.dataset.niuSpecs;
    });
    if (!accordion) return;
    accordion.dataset.niuSpecs = '1';
    const sections = readSpecs(accordion).filter(function (s) { return s.rows.length; });
    if (!sections.length) return;
    accordion.before(buildSpecs(sections));
    accordion.classList.add('niu-hidden');
  }

  // Banners that stay full-screen with the text on the photo (picked by Cornela); all others with centred text
  // become the white split banner
  const FULL_BANNERS = [/excellence technique/i, /cran dynamique couleur/i];

  // The banner's best photo: GemPages keeps one file per device; landscape and the widest win.
  // Lazy images carry an inline SVG spinner in src until they load; the real file is in data-src.
  function bannerImage(banner) {
    const urls = Array.from(banner.querySelectorAll('img')).map(function (i) {
      return i.dataset.src || i.getAttribute('base-src') || i.getAttribute('src') || '';
    }).filter(function (u) { return u && !/^data:|placehold/.test(u); });
    function score(u) {
      const size = u.match(/-(\d{3,4})x(\d{3,4})\./);
      if (!size) return 0;
      const w = +size[1], h = +size[2];
      return (w >= h ? 10000 : 0) + w;
    }
    return urls.sort(function (a, b) { return score(b) - score(a); })[0] || '';
  }

  // Many banner photos were copied into Shopify Files from the global.niu.com Sanity library at a reduced size
  // (e.g. the 2500 x 1406 transmission photo is stored as a 500 x 281 file). Their file names keep the Sanity
  // asset id, so the full-size original is loaded from the Sanity image CDN instead, scaled to 2400 px.
  const SANITY_IMAGES = 'https://cdn.sanity.io/images/cd9iwvgl/production/';
  function sharpImage(url) {
    const asset = url.match(/\/([0-9a-f]{40}-\d{3,5}x\d{3,5}\.(?:jpg|jpeg|png|webp))/i);
    return asset ? SANITY_IMAGES + asset[1] + '?w=2400&fit=max&auto=format&q=85' : url;
  }

  // Full-width banners with centred text over a photo are hard to read on bright images. They become a split
  // banner: photo to the screen edge on one side, text on white on the other, alternating sides. Banners whose
  // text sits on the left were laid out for it and only get a shade behind the text.
  function restyleBanners() {
    // Sides alternate across runs too: banners further down are handled on a later run
    let flip = document.querySelectorAll('.niu-hb-split').length % 2 === 1;
    document.querySelectorAll('gp-hero-banner').forEach(function (banner) {
      const box = Array.from(banner.children).find(function (child) { return child.tagName !== 'SCRIPT'; });
      const row = banner.querySelector('gp-row.gp-hero-banner-row');
      if (!box || box.dataset.niuBanner || box.dataset.niuBannerSkip || banner.parentElement.closest('[data-niu-banner]')) return;
      // A banner without text keeps its GemPages layout; marked so the stylesheet shows it straight away
      if (!row || !Array.from(row.querySelectorAll('h1, h2, h3, p')).some(function (el) { return el.textContent.trim(); })) {
        box.dataset.niuBannerSkip = '1';
        return;
      }
      // The visible heading decides; hidden copies for other devices can carry a different alignment.
      // Before the fonts are in, GemPages keeps the text hidden: try again on the later runs.
      const textEl = Array.from(row.querySelectorAll('h1, h2, h3, p')).find(function (h) { return h.offsetHeight > 0; });
      // GemPages loads a section's styles when it comes near the screen; until then the alignment reads "start"
      const align = textEl ? getComputedStyle(textEl).textAlign : 'start';
      if (align === 'start') return;
      box.dataset.niuBanner = '1';
      const src = bannerImage(banner);
      if (FULL_BANNERS.some(function (pattern) { return pattern.test(row.textContent); })) {
        box.classList.add('niu-hb-shade', 'niu-hb-full');
        const bg = box.querySelector(':scope > .gp-hero-banner-bg .hero-banner-bg');
        if (bg && src) {
          const setPhoto = function (url) { bg.style.setProperty('background-image', 'url("' + url + '")', 'important'); };
          setPhoto(src);
          bg.style.setProperty('background-size', 'cover', 'important');
          bg.style.setProperty('background-position', 'center', 'important');
          // Swap in the full-size original once it has loaded; the Shopify copy stays if it cannot be fetched
          const sharp = sharpImage(src);
          if (sharp !== src) {
            const probe = new Image();
            probe.onload = function () { setPhoto(sharp); };
            probe.src = sharp;
          }
        }
        return;
      }
      if (align !== 'center' || !src) { box.classList.add('niu-hb-shade'); return; }
      const media = document.createElement('figure');
      media.className = 'niu-hb-split__media';
      const img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      // Full-size original first, the Shopify copy as fallback
      img.onerror = function () { img.onerror = null; img.src = src; };
      img.src = sharpImage(src);
      media.append(img);
      row.before(media);
      box.classList.add('niu-hb-split');
      if (flip) box.classList.add('niu-hb-split--rev');
      flip = !flip;
      const section = banner.closest('section');
      if (section) section.classList.add('niu-sec-dark');
    });
  }

  // GemPages ships each section's styles switched off (type "text/disabled-css") and switches them on only once the
  // section has been on screen for about a second. Until then a banner has no layout to read, so it would flash up
  // in its original full-width layout. On the vehicle pages all section styles are switched on straight away instead
  function enableSectionStyles() {
    document.querySelectorAll('style.gps-style[type="text/disabled-css"]').forEach(function (style) { style.type = 'text/css'; });
  }

  // Restyle the banners the moment a section's styles come on, before the browser paints. The stylesheet keeps a
  // banner invisible until it has its layout; one still waiting two seconds after it came into view is shown as
  // GemPages has it, so nothing stays invisible
  let bannerWatch = null;
  let bannerFallback = null;
  function watchBanners() {
    if (!bannerWatch) {
      bannerWatch = new MutationObserver(restyleBanners);
      bannerWatch.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['type'] });
      bannerFallback = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          bannerFallback.unobserve(entry.target);
          setTimeout(function () {
            restyleBanners();
            const box = Array.from(entry.target.children).find(function (child) { return child.tagName !== 'SCRIPT'; });
            if (box && !box.dataset.niuBanner) box.dataset.niuBannerSkip = '1';
          }, 2000);
        });
      });
    }
    // GemPages can add banners after the first run
    document.querySelectorAll('gp-hero-banner:not([data-niu-watched])').forEach(function (banner) {
      banner.dataset.niuWatched = '1';
      bannerFallback.observe(banner);
    });
  }

  // The shop speaks "tu"; the vehicle templates were written with "vous". GemPages does not keep every text
  // edit (four of the six templates dropped them), so the wording is switched here for all of them.
  // Longer phrases first, so a general rule does not break a specific one.
  const TU = [
    ['Vous réservez en ligne, payez votre acompte, et finalisez votre achat', 'Tu réserves en ligne, paies ton acompte et finalises ton achat'],
    ['Vous réservez en ligne, payez votre acompte et finalisez votre achat', 'Tu réserves en ligne, paies ton acompte et finalises ton achat'],
    ['pour vous conseiller et assurer l’entretien de votre NIU', 'pour te conseiller et assurer l’entretien de ton NIU'],
    ['Votre concessionnaire vous contacte', 'Ton concessionnaire te contacte'],
    ['Réglez chez votre concessionnaire', 'Règle chez ton concessionnaire'],
    ['Chez le concessionnaire, réglez', 'Chez le concessionnaire, règle'],
    ['Achetez votre NIU', 'Achète ton NIU'],
    ['Réservez en ligne', 'Réserve en ligne'],
    ['Payez un acompte', 'Paie un acompte'],
    ['choisissez le revendeur', 'choisis le revendeur'],
    ['Finalisez avec le concessionnaire', 'Finalise avec le concessionnaire'],
    ['Retirez votre NIU', 'Retire ton NIU'],
    ['récupérez votre XQi3', 'récupère ta XQi3'],
    ['récupérez votre', 'récupère ton'],
    ['dans votre zone', 'dans ta zone'],
    ['sur mesure pour vous', 'sur mesure pour toi'],
    ['Contactez-nous', 'Contacte-nous'],
    ['vous permettre d’acheter', 'te permettre d’acheter'],
    ['où que vous soyez', 'où que tu sois'],
    ['chez vous', 'chez toi'],
    ['vérifiez immédiatement si votre modèle', 'vérifie immédiatement si ton modèle'],
    ['finalisez votre achat en magasin', 'finalise ton achat en magasin'],
    ['Découvrez', 'Découvre'],
    ['en permanence votre expérience', 'en permanence ton expérience'],
    ['vous pouvez vérifier l\'état de votre véhicule', 'tu peux vérifier l\'état de ton véhicule'],
    ['vous pouvez le retrouver', 'tu peux le retrouver'],
    ['vos données de conduite', 'tes données de conduite'],
    ['amplifier votre parcours', 'amplifier ton parcours'],
    ['vous offre une liberté sans limites. Parcourez', 't’offre une liberté sans limites. Parcours'],
    ['pour vos escapades. Libérez votre côté', 'pour tes escapades. Libère ton côté'],
    ['que vous vous attaquiez', 'que tu t’attaques'],
    ['que vous circuliez', 'que tu circules'],
    ['elle vous donne la liberté de profiter de chaque instant de votre balade', 'elle te donne la liberté de profiter de chaque instant de ta balade'],
    ['vous permettant d\'explorer', 'te permettant d\'explorer'],
    ['La XQi3 vous offre', 'La XQi3 t’offre'],
    ['Accédez à', 'Accède à'],
    ['de votre batterie à l\'historique de vos trajets. Déverrouillez et partez', 'de ta batterie à l\'historique de tes trajets. Déverrouille et pars'],
    ['Conquérez', 'Conquiers'],
    ['Personnalisez les réglages', 'Personnalise les réglages'],
    ['Préparez-vous', 'Prépare-toi'],
    ['Améliorez vos trajets', 'Améliore tes trajets'],
    ['Tournez, cliquez, partez.', 'Tourne, clique, pars.'],
    ['vous donne le contrôle total de votre trajet. Avec le pouce droit, tournez et cliquez', 'te donne le contrôle total de ton trajet. Avec le pouce droit, tourne et clique'],
    ['tout ce que vous aimiez', 'tout ce que tu aimais'],
    ['Vous pourriez aimer', 'Tu pourrais aimer'],
    ['ALIMENTER VOTRE COMMUTING', 'ALIMENTER TON COMMUTING'],
    ['alimenter votre commuting', 'alimenter ton commuting'],
    ['DÉCHAÎNEZ VOTRE ESPRIT', 'DÉCHAÎNE TON ESPRIT'],
    ['Déchaînez votre esprit', 'Déchaîne ton esprit']
  ];

  function switchToTu() {
    const walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      let text = node.nodeValue;
      if (!/vous|votre|vos|VOTRE|ez\b|EZ\b/.test(text)) continue;
      TU.forEach(function (pair) { if (text.indexOf(pair[0]) !== -1) text = text.split(pair[0]).join(pair[1]); });
      if (text !== node.nodeValue) node.nodeValue = text;
    }
  }

  // Accessory cards sit in the buybox right under the photo gallery; they get their own block further down
  function moveAccessories() {
    const buybox = document.querySelector('section.gp-mx-auto');
    if (!buybox) return;
    const grid = Array.from(buybox.querySelectorAll('div.gp-grid')).find(function (g) {
      return g.querySelectorAll('gp-same-height > gp-product, :scope > gp-product').length > 1 && !g.closest('.niu-pdp-acc');
    });
    if (!grid) return;
    // The buybox component that holds the list: child of a column of the section's top row
    let item = grid;
    while (item.parentElement && item.parentElement.parentElement && !(item.parentElement.parentElement.tagName === 'GP-ROW' && item.parentElement.parentElement.parentElement === buybox)) item = item.parentElement;
    const block = document.createElement('section');
    block.className = 'niu-pdp-acc';
    block.innerHTML = '<div class="niu-pdp-acc__wrap"><h2 class="niu-pdp-acc__title">Accessoires</h2></div>';
    block.firstChild.append(item);
    const faq = document.querySelector('section.niu-pdp-faq');
    (faq || buybox).after(block);
  }

  // White line between the full-width blocks; the 360° viewer and other embeds get black space around them
  function separateSections() {
    const sections = Array.from(document.querySelectorAll('section.gp-mx-auto, section.niu-pdp-faq, section.niu-pdp-acc'));
    sections.forEach(function (section, index) {
      if (index > 0) section.classList.add('niu-sep');
      if (section.querySelector('gp-carousel iframe')) section.classList.add('niu-sec-dark', 'niu-sec-embed');
    });
  }

  // A GemPages product block whose product does not exist in this shop prints "Product not found"; the block
  // is hidden until its source is fixed in GemPages (the fix is in the drafts, live after republishing)
  function hideMissingProducts() {
    const main = document.querySelector('main');
    if (!main) return;
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    const found = [];
    let node;
    while ((node = walker.nextNode())) if (node.nodeValue.trim() === 'Product not found') found.push(node.parentElement);
    // Hide the largest block that holds nothing but this message (usually the whole GemPages section)
    found.forEach(function (el) {
      let box = el;
      while (box.parentElement && box.parentElement !== main && box.parentElement.textContent.trim() === 'Product not found') box = box.parentElement;
      box.classList.add('niu-hidden');
    });
  }

  // The dealer search (Storepoint widget) gets an anchor so the full-screen banners can link to it
  const DEALERS_ID = 'concessionnaires';
  function markDealerSearch() {
    const widget = document.getElementById('storepoint-widget');
    const section = widget && widget.closest('section.gp-mx-auto');
    if (section && !section.id) section.id = DEALERS_ID;
    return section;
  }

  function addDealerButtons() {
    if (!markDealerSearch()) return;
    document.querySelectorAll('.niu-hb-full').forEach(function (box) {
      if (box.querySelector('.niu-hb-cta')) return;
      const texts = Array.from(box.querySelectorAll('gp-row h1, gp-row h2, gp-row h3, gp-row p')).filter(function (el) { return el.offsetHeight > 0; });
      const last = texts[texts.length - 1];
      if (!last) return;
      const link = document.createElement('a');
      link.className = 'niu-hb-cta';
      link.href = '#' + DEALERS_ID;
      link.textContent = 'Trouve ton concessionnaire';
      link.addEventListener('click', function (event) {
        const target = document.getElementById(DEALERS_ID);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      last.after(link);
    });
  }

  // Section order agreed with Cornela for all vehicle pages: buybox, picture/text banners, full-screen banner,
  // gallery, specs, FAQ, accessories, dealer search. Other blocks keep their place after the banners.
  // Vehicle pages are the ones with the dealer search; accessory pages keep their own order.
  function reorderSections() {
    const main = document.querySelector('main');
    if (!main || main.dataset.niuOrder || !document.getElementById('storepoint-widget')) return;
    const wrappers = Array.from(main.children).filter(function (el) { return el.matches('section.gp-mx-auto') || el.querySelector(':scope > section.gp-mx-auto'); });
    if (wrappers.length < 3) return;
    main.dataset.niuOrder = '1';
    function isFull(el) {
      return Array.from(el.querySelectorAll('gp-hero-banner')).some(function (b) {
        return FULL_BANNERS.some(function (p) { return p.test(b.textContent); });
      });
    }
    const groups = { banner: [], full: [], gallery: [], other: [], specs: [], dealer: [] };
    const buybox = wrappers.shift();
    wrappers.forEach(function (el) {
      if (el.querySelector('#storepoint-widget')) groups.dealer.push(el);
      else if (el.querySelector('.niu-specs, gp-accordion') && /caract[ée]ristiques/i.test(el.textContent)) groups.specs.push(el);
      else if (isFull(el)) groups.full.push(el);
      else if (el.querySelector('gp-hero-banner')) groups.banner.push(el);
      else if (el.querySelector('gp-carousel') && !el.innerText.trim()) groups.gallery.push(el);
      else groups.other.push(el);
    });
    // FAQ and accessories were built inside the buybox wrapper and move behind the specs. GemPages scopes its
    // styles to the wrapper's gps-… class, so they travel in a wrapper with the same classes.
    const tail = document.createElement('section');
    tail.className = buybox.className;
    tail.classList.add('niu-pdp-tail');
    ['section.niu-pdp-faq', 'section.niu-pdp-acc'].forEach(function (selector) {
      const block = document.querySelector(selector);
      if (block) tail.append(block);
    });
    const ordered = [].concat(groups.banner, groups.other, groups.full, groups.gallery, groups.specs, [tail], groups.dealer);
    const marker = document.createComment('niu-order');
    buybox.after(marker);
    ordered.forEach(function (el) { main.insertBefore(el, marker); });
    marker.remove();
  }

  // GemPages buttons for sold-out and unavailable variants carry its English default labels, on every page
  const BUTTON_LABELS = { 'Out of stock': 'Épuisé', 'Sold out': 'Épuisé', 'Unavailable': 'Indisponible' };
  function frenchButtonLabels() {
    document.querySelectorAll('button.gp-button-base').forEach(function (button) {
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const label = BUTTON_LABELS[node.nodeValue.trim()];
        if (label) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), label);
      }
    });
  }

  // Product cards (collections, Bons plans, home page): colour dots under the title, read from the shop's product data
  const COLOURS = { noir: '#121212', 'noir mat': '#2B2B2B', blanc: '#F5F5F5', 'blanc mat': '#E9E8E2', gris: '#8C8C8C', 'gris mat': '#6E6E6E', bleu: '#1F4E9A', rouge: '#DF001F', jaune: '#F5C400', vert: '#4B5D45', violet: '#6B3FA0' };
  let colourData = null;
  function addColourDots() {
    const cards = Array.from(document.querySelectorAll('gp-product[gp-context]')).filter(function (card) {
      return !card.dataset.niuColours && !card.querySelector('gp-product-variants') && card.querySelector('gp-product-title h2, gp-product-title h3');
    });
    if (!cards.length) return;
    if (!colourData) {
      colourData = fetch('/products.json?limit=250').then(function (response) { return response.json(); }).then(function (data) {
        const byVariant = {};
        data.products.forEach(function (product) {
          const option = product.options.find(function (o) { return /couleur|colou?r/i.test(o.name); });
          if (option) product.variants.forEach(function (v) { byVariant[v.id] = option.values; });
        });
        return byVariant;
      });
    }
    colourData.then(function (byVariant) {
      cards.forEach(function (card) {
        if (card.dataset.niuColours) return;
        card.dataset.niuColours = '1';
        let variant = null;
        try { variant = JSON.parse(card.getAttribute('gp-context')).variantSelected; } catch (e) { return; }
        const values = variant && byVariant[variant.id];
        const title = card.querySelector('gp-product-title h2, gp-product-title h3');
        if (!values || values.length < 2) return;
        const row = document.createElement('div');
        row.className = 'niu-card-colours';
        values.forEach(function (name) {
          const dot = document.createElement('span');
          dot.className = 'niu-card-colours__dot';
          dot.title = name;
          dot.style.background = COLOURS[name.toLowerCase()] || '#C8C8C8';
          row.append(dot);
        });
        const label = document.createElement('span');
        label.className = 'niu-card-colours__label';
        label.textContent = values.length + ' couleurs';
        row.append(label);
        title.after(row);
      });
    }).catch(function () { colourData = null; });
  }

  // Leftover GemPages sections with nothing visible in them (no text, no embed, at most one hidden picture)
  // only add white space between the blocks
  function hideEmptySections() {
    document.querySelectorAll('main > .shopify-section > section.gp-mx-auto').forEach(function (section) {
      if (section.innerText.trim() || section.querySelector('iframe, video, #storepoint-widget')) return;
      if (section.querySelectorAll('img').length <= 1 && section.offsetHeight < 300) section.classList.add('niu-hidden');
    });
  }

  function run() {
    frenchButtonLabels();
    addColourDots();
    // Loaded on every page (snippets/my-js.liquid); only product templates and their GemPages preview get the changes
    const isProductPage = document.body.classList.contains('template-product') || /page_type=GP_PRODUCT/.test(location.search);
    if (!isProductPage) return;
    document.documentElement.classList.add('niu-pdp');
    watchBanners();
    enableSectionStyles();
    tidyBuybox();
    moveStepsHeading();
    addDeliveryTime();
    restyleSpecs();
    moveAccessories();
    // Banners whose GemPages styles are not in yet are skipped here and picked up by watchBanners()
    restyleBanners();
    hideMissingProducts();
    if (document.readyState === 'complete') hideEmptySections();
    reorderSections();
    addDealerButtons();
    separateSections();
    switchToTu();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // GemPages fills some blocks (cards, lazy sections) after load
  window.addEventListener('load', function () { run(); setTimeout(run, 1500); });
  // Picking a sold-out variant swaps the button label
  document.addEventListener('change', function () { setTimeout(frenchButtonLabels, 60); });
  document.addEventListener('click', function () { setTimeout(frenchButtonLabels, 60); });
  // Sections further down get their styles and content while scrolling
  let scrollTimer = null;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; run(); }, 500);
  }, { passive: true });
})();
